module.exports = {
  details: "详情",
  edit: "编辑",
  opera: "操作",
  delete: "删除",
  create: "新增",
};
